const state = {
  showBookIndex: false,
  bookIndexActive: false,
};

const mutations = {
  BOOK_INDEX_ACTIVE(state, bookIndexActive) {
    state.bookIndexActive = bookIndexActive;
  },
  SHOW_BOOK_INDEX(state, showBookIndex) {
    state.showBookIndex = showBookIndex;
  },
};

const actions = {
  someAsyncTask({ commit }) {
    // do something async
    commit('TEST');
  },
};

const getters = {
  showBookIndex: (state) => {
    return state.showBookIndex;
  },
  bookIndexActive: (state) => {
    return state.bookIndexActive;
  },
};
export default {
  state,
  mutations,
  actions,
  getters,
};
